import axiosVApi from '../axiovishwam';


export async function getModuleDropdown(request) {
    try {
        const response = await axiosVApi.post(`/Module/GetModuleDropdown`, request);
        return response?.data?.data;
    } catch (error) {
        console.log("Error getApplicationDropdown===>:", error);
 return error?.response?.data;
    }
};


export const ModuleService = {
    getModuleDropdown,
}
